import { h, render } from 'preact'

export default function renderApp(App){
  const main = document.querySelector('main')
  main.innerHTML = ''
  render(<App />, main)
}
